<template>
  <main id="main-content" class="page page--topic">
    <div class="page__content">
      <div class="topic__meta u-relative">
        <div class="topic-people avatar-group avatar-group--stacked">
          <img
            src="..//assets/heyteam-logo.png"
            alt="The HEY Team"
            title="The HEY Team <support@hey.com>"
            class="avatar"
            width="50"
            height="50"
          />
          <img
            src="..//assets/nicola-icon.jpg"
            alt="Nicola Bolton"
            title="Nicola Bolton <nicolaebolton@gmail.com>"
            class="avatar avatar--small"
            width="50"
            height="50"
          />
        </div>
      </div>

      <Heading title="Why I want to be your next Senior Designer 👋" />

      <div class="sheet">
        <Posting
          heading="Nicola Bolton"
          sender="nicolaebolton@gmail.com"
          detail="to The HEY Team"
          date="Oct 12"
          profile="nicola-icon.jpg"
          url
        />

        <div class="entry__body">
          <h2>Hi! Nice to meet you, I'm Nicola.</h2>
          <p>Sending you a traditional cover letter and link to a portfolio didn't seem like enough for the job of a lifetime. I wanted to step out of my comfort zone and challenge myself. So I developed this small application as an ode to HEY and have a little fun with your brand.</p>
          <h3>A little about me...</h3>
          <p>I’m a hybrid designer and developer with an obsession for clean, intuitive design. A creative “unicorn” who delights in iterating design ideas and seeing them come to life. In my 12 years of experience, I've designed digital experiences in a variety of contexts; at agencies and design studios, as well as with start-ups, and in-house teams. You name it, I've designed it: brand guidelines, UI interfaces, coffee cups, even a COVID-19 planning tool. If it’s something I've not yet come across, then bring on the challenge!</p>
          <p>Inspired by people and their stories, the heartbeat behind my mission is to foster meaningful connections through the power of curiosity, empathy and honesty. I have a strong craving to make every artifact reusable, I care about the details and work enthusiastically to come up with elegant solutions that promote ease of use. I consider prototyping to be my weapon of choice in thinking through interactions and new concepts. I thrive on learning new things and I enjoy exploring new paths to familiar places.</p>
          <p>Get to know me and you'll quickly learn that I have an insatiable desire to explore the world and see things from fresh perspectives. Away from the screen, I enjoy snowboarding, surfing, seeing my favourite bands, exploring Vancouver’s many trails, and spending time with family and friends.</p>
          <h3>Ready to be at your service!</h3>
          <p>You’re looking for a creative generalist—someone with initiative, who can make calls that consider both business and consumer needs and who delivers projects with minimal oversight. I have vast experience working on projects from concept to execution—across many platforms. In another life, I started my own independent agency where I assisted over 30 start-ups and small companies. While my roles in these projects varied slightly in title; from Creative Director, to Front End Developer, to Project Manager, to Wordsmith, to Invoice Chaser &mdash; all of them focused on creating design solutions from a user centered perspective in the form of digital products and services.</p>
          <p>I’ve always taken pride in my ability to deliver compelling design and production-ready code. I have found it to be an incredibly strong asset which has helped bridge the gap and ease collaboration between teams. I put in the work to get to where I am because I see the beauty in both and believe it has made me a more considered designer for it. Both professionally and personally, I would describe myself as calm, versatile and always the first to offer support when someone is in need. Having delved deeper into Basecamp’s philosophy, it is evident that you share these same values.</p>
          <h3>What’s in it for me?</h3>
          <p>As someone who always strives to learn, improve and evolve, I am keen to take on a new adventure and believe Basecamp is the place where I can master my skill and make a life-long career.</p>
          <p>There is no denying the perks sound incredibly enticing, but my reasons go much deeper than that. I long to work in an environment that nurtures creativity, simplicity and “doing the right thing”. I would love the opportunity to work alongside your talented team to share knowledge and continue to make exceptional products together. I have a lot to give but know my best is yet to come. That right there sounds pretty darn exciting to me!</p>
          <p>I look forward to finding out more about the challenges the team is currently facing and discuss how I can contribute and make my mark at Basecamp.</p>
          <p>You can learn more about my work in my resume and portfolio.</p>
          <p>Thank you for your time and consideration,</p>
          <p>— Nicola</p>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import Heading from "@/components/Heading";
import Posting from "@/components/Posting";

export default {
  name: "Letter",
  metaInfo: {
    title: "Why I want to be your next Senior Designer",
    titleTemplate: "%s | HEY"
  },
  components: {
    Heading,
    Posting
  }
};
</script>
